import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useOauth2Client, useOauth2Principal } from '../oauth2.hooks';
import { goToDashboard } from '../../actions/changePassword';
import Spinner from '../../components/loading/spinner';
import useSearchParams from '../../hooks/useSearchParams';
import { useIntl } from 'react-intl';

const Oauth2LoginError = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <p>{formatMessage({ id: 'login.error.prefix' })}</p>
      <p>{formatMessage({ id: 'login.error.message.general' })}</p>
      <p>{formatMessage({ id: 'login.error.retryHint' })}</p>
    </>
  );
}

const Oauth2LoginRedirect = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useOauth2Principal();
  const { loginRedirect } = useOauth2Client();

  useEffect(() => {
    if (isAuthenticated === true) {
      dispatch(goToDashboard());
    } else if (isAuthenticated === false) {
      loginRedirect();
    }
  }, [isAuthenticated, loginRedirect, dispatch]);

  return <Spinner />;
};

const Oauth2Login = () => {
  const searchParams = useSearchParams();

  if (searchParams.get('error')) {
    return <Oauth2LoginError />;
  }
  return <Oauth2LoginRedirect />;
};

export default Oauth2Login;
